import React from 'react';

import { Link } from 'react-router-dom';

import { Button } from 'components/uikit/Button/Button';

import { usePageBottomPresenter } from './PageBottom.presenter';
import * as S from './PageBottom.styles';

export const PageBottom = ({ children }) => {
  const presenter = usePageBottomPresenter();

  return (
    <S.PageBottom>
      <S.Wrapper>
        <Button as={Link} size="m" theme="3" to={presenter.previousPagePath}>
          Перейти на Главную
        </Button>
        <S.Wrapper>{children}</S.Wrapper>
      </S.Wrapper>
    </S.PageBottom>
  );
};
